window.addEventListener("klaviyoForms", async function(e) {
  if (e.detail.type == 'submit') {
    if ( window.dataLayer && typeof window.dataLayer.push === 'function' ) {
      window.dataLayer.push( {'event': 'Klaviyo Form Submission', 'klaviyoForm': e.detail.formId} );
    }
    // Peitition form on both petition/sweeps page
    if (e.detail.formId === 'UfHwUk') {
      const signUpCard = document.querySelector('.vt-signup .vt-signup__card');
      if (signUpCard && window.innerWidth < 768) {
        window.scrollTo({ top: signUpCard.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' });
      }

      // Update our count based on whenever this form successfully submits
      const { token } = await fetch('https://letitryed.com/wp-json/petition/v1/token')
        .then(r => r.json());
      
      const response = await fetch('https://letitryed.com/wp-json/petition/v1/count', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Petition-JWT': token
        },
      });
    }
  }
});